import BarcodeScanMap from '~/terra/pages/barcode-scan-map.vue';
import TerraCompare from '~/terra/pages/terra-compare.vue';
import TerraViewer from '~/terra/pages/terra-viewer.vue';

const routes = [
  {
    path: '/:asset_id?/terra-viewer/:id?',
    name: 'terra-viewer',
    component: TerraViewer,
    meta: {
      title: 'Terra viewer',
      view_name: 'Terra viewer',
      requireModuleAccess:"terra",
    },
  },
  {
    path: '/:asset_id?/maps/:id?',
    name: 'maps',
    component: TerraViewer,
    meta: {
      title: 'Terra viewer',
      view_name: 'Terra viewer',
      requireModuleAccess:"terra"
    },
  },
  {
    path: '/:asset_id?/terra/:id?/compare',
    name: 'terra-compare',
    component: TerraCompare,
    meta: {
      title: 'Terra viewer',
      view_name: 'Terra viewer - Compare',
      requireModuleAccess:"terra"
    },
  },
  {
    path: '/:asset_id?/maps/:id?/compare',
    name: 'maps-compare',
    component: TerraCompare,
    meta: {
      title: 'Maps',
      requireModuleAccess:"terra"
    },
  },
  {
    path: '/:asset_id?/barcode-scan/:id?',
    name: 'terra-barcode-scan',
    component: BarcodeScanMap,
    meta: {
      title: 'Barcode Scan View',
      view_name: 'Barcode Scan',
      is_barcode_view: true,
      requireModuleAccess:"terra"
  },
  }
];
export default routes;
